const CHAT_BUBBLE_CLEARANCE_PX = 76;

class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    this.target = document.getElementById(this.dataset.targetId);
    if (!this.target || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('product-sticky-bar--visible', scrolledPast);
        this.updateChatBubble(scrolledPast);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.updateChatBubble(false);
  }

  updateChatBubble(barVisible) {
    // The WhatsApp widget positions itself with both `top` and `bottom` set
    // (each computed from the viewport height by its own stylesheet), so a
    // fixed box is over-constrained: overriding `bottom` alone is a no-op
    // per the CSS spec (browsers ignore it and re-derive it from top+height),
    // and overriding `top` alone stretches the box instead of moving it,
    // because `bottom` is still pinning its other edge. Freeing `bottom` to
    // `auto` and locking `height` while moving `top` is what actually shifts
    // it as one rigid block.
    const bubble = document.getElementById('chat-bubble');
    if (!bubble) return;

    if (barVisible) {
      if (this.chatBubbleOriginalTop == null) {
        this.chatBubbleOriginalTop = parseFloat(getComputedStyle(bubble).top);
        this.chatBubbleOriginalHeight = bubble.getBoundingClientRect().height;
      }
      bubble.style.setProperty(
        'top',
        this.chatBubbleOriginalTop - CHAT_BUBBLE_CLEARANCE_PX + 'px',
        'important'
      );
      bubble.style.setProperty('bottom', 'auto', 'important');
      bubble.style.setProperty('height', this.chatBubbleOriginalHeight + 'px', 'important');
      bubble.style.setProperty('transition', 'top 0.25s ease', 'important');
    } else {
      bubble.style.removeProperty('top');
      bubble.style.removeProperty('bottom');
      bubble.style.removeProperty('height');
      bubble.style.removeProperty('transition');
    }
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);
